import { combineReducers } from 'redux';

import alyxReducer from './reducers/alyxReducer';
import screenReducer from './reducers/screenReducer';
import gameProgressReducer from './reducers/gameProgressReducer';
import roundPlayReducer from './reducers/roundPlayReducer';

// keeping the reducer collection as a separate exported object enables us
// to do some light test automation on every reducer.
// see ./reducers/__tests__/reducerRejections.test.js
// for more details.
export const reducerCollection = {
  alyx: alyxReducer,
  screen: screenReducer,
  gameProgress: gameProgressReducer,
  roundPlay: roundPlayReducer,
};

const reducers = combineReducers({ ...reducerCollection });

export default reducers;
